/**
 * @deprecated Import from ~/common/utils/formatting or ~/app/config/appConstants where possible.
 * This file re-exports for backward compatibility.
 */

// Re-export formatting constants
// NOTE: FORMATTING_LOCALE_CODE was removed — it is now read lazily from the runtime-config
// registry (getRuntimeConfig().formattingLocale), populated by the bootstrap fetch (ADR 0003).
export {
  DEFAULT_FRACTION_DIGITS,
  WEIGHT_DECIMAL_DIGITS,
  DEFAULT_UNIT_SYMBOL,
  ENGLISH_LOCALE_CODE,
  FALLBACK_DECIMAL_SEPARATOR,
  FALLBACK_THOUSAND_SEPARATOR,
  POINT_DECIMAL_SEPARATOR,
  COMMA_DECIMAL_SEPARATOR,
  FALLBACK_DATE_FORMAT,
  FALLBACK_DATETIME_FORMAT,
  FALLBACK_TIME_FORMAT,
  NBSP,
  NON_BREAKING_HYPHEN,
} from "~/common/utils/formatting";

// Re-export app config constants.
// Only the two module-scope language values remain (needed at i18n init, read from
// window.__SCHA_BOOT__, ADR 0003). All other former appConstants migrated off window.SCHA:
// bootstrap config → useAppConfig() / getRuntimeConfig(); session config → useSession() /
// getRuntimeConfig(); GOOGLE_GEOAPI_KEY / CC_MIN_JS_FILE_URL → useAppConfig; SALES_REP_PHONE_NO →
// useSession; MAX_VISIBLE_PRICE_SCALE removed.
export { DEFAULT_LANGUAGE, CURRENT_LANGUAGE } from "~/app/config/appConstants";

// Quantity constants
export const MAX_QUANTITY = 9999999; // 7 times "9"
export const MAX_QUANTITY_LENGTH = MAX_QUANTITY.toString().length;
export const MAX_QUANTITY_FORMAT = "9.999.999";
export const MAX_QUANTITY_FORMAT_LENGTH = MAX_QUANTITY_FORMAT.length;
export const MAX_TEXT_LENGTH_CONTACT_FORMS = 2000;

export const SELF_DISMISSABLE_TOASTS_TOP = 7000; // 7000 ms -> 7s

// Form field lengths
export const PO_NUMBER_LENGTH = 35;
export const ACCOUNT_NUMBER_LENGTH = 35;
export const ORDER_COMMENT_LENGTH = 512;

// Debounce times
export const AUTOSUGGEST_DEBOUNCE_TIME = 300;
export const AUTOSUGGEST_MAX_LENGTH = 5;
export const CADTABLE_DEBOUNCE_TIME = 900;
export const SEARCH_SCROLL_DEBOUNCE_TIME = 250;

// Package/Product constants
export const INVALID_PACKAGE_CODE = "XX";
export const NO_PRICE_REFERENCE = "";
export const EXPRESS_DELIVERY_CODE = "EXPRESS";
export const DST_PRODUCT_CODE = "DST";
export const DST_SAP_MAT_NO = "0952597240000";

// Quote constants
export const QUOTE_ENTRY_REJECTED = "EV01";
export const QUOTE_ENTRY_IN_CLARIFICATION = "IV01";

// URL/Navigation constants
export const EDIT_USER_URL = "/my-company/organization-management/manage-users/edit";
export const URL_LANGUAGE_PARAM = "lang";

// Search/Filter constants
export const DEFAULT_FILTER_CONFIG = "DEFAULT";
export const MAX_COLUMNS_IN_TABULAR_VIEW = 7;
export const PRODUCT_VARIANT_TABLE_TOGGLE_THRESHOLD = 7;
export const SEARCH_TECH_VALUE_TABLE_THRESHOLD = 5;

// Validation patterns
export const EMAIL_PATTERN = /^[_A-Za-z0-9-+]+(\.[_A-Za-z0-9-']+)*@[A-Za-z0-9-]+(\.[A-Za-z0-9]+)*(\.[A-Za-z]{2,})$/;

// PDP Tab constants
export const MOUNTING_TAB = "productDetailsPage.tabs.mounting";
export const MOUNTING_INFORMATION_TAB = "productDetailsPage.tabs.mountinginformation";
export const MOUNTING_MANAGER_TAB = "productDetailsPage.tabs.mountingmanager";

// Configurator constants
export const SHARE_LINEAR_CONFIGURATIONS_CODE_SEPARATOR = ",";
export const KITS_MODAL_LAYOUT_REQUEST_PARAM = "?modalCls=scha__lc__kits-table";

// Language constants
export const ENGLISH_LANGUAGE = "en";
export const GERMAN_LANGUAGE = "de";
export const ENGLISH_EXTERNAL_CONTENT_SUFFIX = "_en-GB.html";
export const GERMAN_EXTERNAL_CONTENT_SUFFIX = "_de-DE.html";

// Header layout constants
export const HEADER_BREAKPOINT_LOGO = 600;
export const MQ_HEADER_BREAKPOINT_LOGO = `(min-width:${HEADER_BREAKPOINT_LOGO}px)`;

const NAV_BAR_HEIGHT_PHONE = 48;
const NAV_BAR_HEIGHT_TABLET = 48;
const NAV_BAR_HEIGHT_DESKTOP = 67;

const SCHA_LOGO_HEIGHT_S = 17;
const SCHA_LOGO_HEIGHT_M = 23;

/* special case - 320-599px */
export const HEADER_HEIGHT_PHONE = `${SCHA_LOGO_HEIGHT_S * 3 + NAV_BAR_HEIGHT_PHONE}px`;
export const REGION_BAR_HEIGHT_PHONE = `165px`;
/* special case - 600px-tablet */
export const HEADER_HEIGHT_PHONE_BIG = `${SCHA_LOGO_HEIGHT_M * 3 + NAV_BAR_HEIGHT_PHONE}px`;
export const HEADER_HEIGHT_TABLET = `${SCHA_LOGO_HEIGHT_M * 3 + NAV_BAR_HEIGHT_TABLET}px`;
export const HEADER_HEIGHT_DESKTOP = `${SCHA_LOGO_HEIGHT_M * 3 + NAV_BAR_HEIGHT_DESKTOP}px`;
export const REGION_BAR_HEIGHT = `80px`;

// Layout width constants
export const WIDE = "wide";
export const NARROW = "narrow";

// Target constants
export const _BLANK = "_BLANK";
export const BLANK = "BLANK";

// PDP - Downloads Tab - Publication on page (desktop / mobile)
export const PUBS_ON_DESKTOP = 40;
export const PUBS_ON_MOBILE = 10;

// Cookie consent
export const MOVING_IMAGE_COOKIE_CONSENT_GROUP = "C0002";

// User/Company constants
export const EMPTY_JOB_TITLE_CODE = "1001";

// Customer categories
export const CUSTOMER_CATEGORY = "cc_customer";
export const DISTRIBUTOR_CATEGORY = "cc_distributor";
export const SERVICE_PROVIDER_CATEGORY = "cc_service_provider";
export const SCHAEFFLER_INTERNAL_CATEGORY = "cc_schaeffler_internal";
